// Cross-component trigger for the live support chat.
//
// LiveChatWidget owns its own open/unread state, and its floating launcher is
// hidden on phones (it sat in the same bottom-right corner as the page FABs and
// covered the "add" button). On phones support is opened from the nav menu
// instead, which needs a way to reach the widget without threading state
// through App.js.

/** Fired to open the support chat panel. */
export const OPEN_SUPPORT_CHAT_EVENT = "groomsy:open-support-chat";

/** Fired by the widget when its unread count changes, so menus can badge it. */
export const SUPPORT_CHAT_UNREAD_EVENT = "groomsy:support-chat-unread";

export function openSupportChat() {
  window.dispatchEvent(new CustomEvent(OPEN_SUPPORT_CHAT_EVENT));
}
